 import "../styles/ServiceList.css";
import Booking from './Booking';
import { useState } from 'react';
import { Helmet } from 'react-helmet';

function ServiceList() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const services = [
    {
      title: "1-on-1 Training",
      icon: "/media/icons/1-on-1-icon.png",
      alt: "1-on-1 personal training icon",
      description: "Tailored fitness sessions focused on your unique goals, pace, and lifestyle.",
    },
    {
      title: "Boxing Fitness",
      icon: "/media/icons/boxing-icon.png",
      alt: "Boxing gloves icon",
      description: "High-intensity boxing workouts designed to improve strength, cardio, and confidence.",
    },
    {
      title: "Online Coaching",
      icon: "/media/icons/online-coaching.png",
      alt: "Laptop with dumbbell icon",
      description: "Train anywhere, anytime with structured online coaching and progress tracking.",
    },
    {
      title: "House Calls",
      icon: "/media/icons/house-calls-icon.png",
      alt: "Trainer visiting a home icon",
      description: "Don’t leave the house—our trainer brings the workout to you for maximum convenience.",
    },
  ];

  return (
    <section id="services" aria-labelledby="services-heading">
      <Helmet>
        <title>Personal Training Services | Lu - Fit</title>
        <meta name="description" content="Explore boxing, online coaching, 1-on-1 personal training, and house calls offered by Lu - Fit. Designed to meet your fitness goals." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Personal Training",
            "provider": {
              "@type": "Organization",
              "name": "Lu - Fit Personal Training",
              "url": "https://yourdomain.com"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Fitness Services",
              "itemListElement": services.map((service) => ({
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": service.title,
                  "description": service.description
                }
              }))
            }
          })}
        </script>
      </Helmet>

      <h2 id="services-heading" className="services-subtitle-heading">
        Personal Training Services Tailored For You
      </h2>

      <p className="services-subtitle">
        Whether you're looking to train in-person or online, Lu - Fit offers flexible options to help you reach your fitness goals effectively.
      </p>

      <div className="service-list-container">
        {services.map((service, idx) => (
          <article className="service-card" key={idx} aria-label={`Service: ${service.title}`}>
            <img
              src={service.icon}
              alt={service.alt}
              className="service-icon"
              width="64"
              height="64"
              loading="lazy"
            />
            <h3 className="service-card-title">{service.title}</h3>
            <p className="service-card-description">{service.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ServiceList;
